import React from "react";
import styles from "./CTASection.module.css";
import { Container } from "../../common/Container";
import { AppStoreBadge } from "./AppStoreBadge";
import { ctaData } from "../../../data/compassData";

export const CTASection: React.FC = () => (
  <section className={styles.section} aria-labelledby="cta-title">
    <Container>
      {/* The band borrows the app's Today's Alignment card gradient. */}
      <div className={styles.band}>
        <div className={styles.copy}>
          <h2 id="cta-title" className={styles.title}>
            {ctaData.headline}
          </h2>
          <p className={styles.subtitle}>{ctaData.subheadline}</p>
          <AppStoreBadge tone="light" />
          <p className={styles.note}>{ctaData.note}</p>
        </div>

        {/* Desktop visitors can't install an iOS app from here, so hand off to the phone. */}
        <figure className={styles.qr}>
          <img
            src="/images/compass/qr-app-store.svg"
            alt="QR code linking to Compass on the App Store"
            width={148}
            height={148}
            loading="lazy"
          />
          <figcaption>{ctaData.qrLabel}</figcaption>
        </figure>
      </div>
    </Container>
  </section>
);
